module.exports = __webpack_public_path__ + "img/about-top.cc45f16d.png";